import React from "react";
import { useField, useFormikContext } from "formik";
import DatePicker from "react-datepicker";

const getFieldCSSClasses = (currentClass, touched, errors) => {
  const classes = [currentClass, ""];
  if (touched && errors) {
    classes.push("is-invalid");
  }

  if (touched && !errors) {
    classes.push("is-valid");
  }

  return classes.join(" ");
};

export function DatePickerField({ required, inputClass, ...props }) {
  const { setFieldValue, errors, touched } = useFormikContext();
  const [field] = useField(props);
  return (
    <>
      {props.label && (
        <label>
          {props.label}
          {required && <span style={{ color: "red" }}> *</span>}
        </label>
      )}
      <DatePicker
        className={`form-control ${getFieldCSSClasses(
          inputClass,
          touched[field.name],
          errors[field.name]
        )}`}
        wrapperClassName={`w-100 ${getFieldCSSClasses(
          inputClass,
          touched[field.name],
          errors[field.name]
        )}`}
        style={{ width: "100%" }}
        {...field}
        {...props}
        selected={(field.value && new Date(field.value)) || null}
        onChange={(val) => {
          setFieldValue(field.name, val);
        }}
      />
      {errors[field.name] && touched[field.name] && (
        <div className="invalid-feedback">{errors[field.name].toString()}</div>
      )}
    </>
  );
}
